import store from "../../store";

export default function ({next, router}) {

    // Jeśli użytkownik nie jest zalogowany to lecimy dalej
    // Token jest weryfikowany na początku, więc mamy pewność
    // że w tym miejscu jest on poprawny
    if (!! store.state.Auth.token === false) {
        return next();
    }

    return router.push({name: 'Applications'});

}